module.exports = __webpack_public_path__ + "Flag-834.5409fc5993cf5609784436f407858934.svg";